import { Box } from '@mui/material';
import React from 'react';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
import EmployeePrivilegesComponent from './EmployeePrivilegesComponent';
import WeekendWorkingPrivileges from './WeekendWorkingPrivileges';

function EmployeePrivilegesTabComponent() {
  const [activeTab, setActiveTab] = React.useState(0);
  const MasterdataTabs = [
    {
      title: 'HOME QUOTA',
      index: 0,
      component: <EmployeePrivilegesComponent type="wfh" />,
    },
    {
      title: 'LEAVE QUOTA',
      index: 1,
      component: <EmployeePrivilegesComponent type="leave" />,
    },
    {
      title: 'EXTERNAL HOURS QUOTA',
      index: 2,
      component: <EmployeePrivilegesComponent type="external" />,
    },
    {
      title: 'CLIENT OFFICE QUOTA',
      index: 3,
      component: <EmployeePrivilegesComponent type="clientOffice" />,
    },
    {
      title: 'WORK TRAVEL HOURS QUOTA',
      index: 4,
      component: <EmployeePrivilegesComponent type="workTravel" />,
    },
    {
      title: 'WEEKEND WORKING HOURS',
      index: 5,
      component: <WeekendWorkingPrivileges />,
    },
  ];
  return (
    <div>
      <Box className="main-content-overlay">
        <div className="main-content-div">
          <div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={MasterdataTabs}
            />
          </div>
        </div>
      </Box>
    </div>
  );
}

export default EmployeePrivilegesTabComponent;
